import type { SimpleTaskFragment } from "@src/__generated__/graphql";
import { ModalTaskCreate } from "@src/components/widgets/Modals/ModalTask";
import type { AppStore } from "@src/stores/AppStore";
import type { BaseStore } from "@src/stores/BaseStore";
import type { ModalStore } from "@src/stores/ModalStore";
import { DisclosureState } from "@src/utils/mobx/states/DisclosureState";
import type { OurWorkBudgetItemForLabel } from "@src/widgets/TaskSelect/TaskSelect";
import { makeObservable, observable } from "mobx";

type OpenOptionsBase = {
  onSubmit?: (data: SimpleTaskFragment) => void;
  hideCreateAllocationsCheckbox?: boolean;
  userId?: string;
  /** Preselected status, e.g. the board column the task is created in. */
  taskStatusId?: string;
  /** Preselected priority, e.g. the board column the task is created in. */
  taskPriorityId?: string;
};
type ParentTask = Pick<SimpleTaskFragment, "id" | "name" | "status"> & {
  ourWorkBudgetItem?: OurWorkBudgetItemForLabel | null;
};
type OpenOptionsExtra =
  | {
      projectId: string;
      budgetItemId: string;
      billable: boolean;
      parentTask: ParentTask;
      isTemplate: boolean;
      templateGroupId?: string;
      filterParentTasksForGroup?: boolean;
      is_starred?: boolean;
    }
  | {
      projectId?: string;
      budgetItemId?: string;
      billable?: boolean;
      parentTask?: ParentTask;
      isTemplate?: boolean;
      templateGroupId?: string;
      filterParentTasksForGroup?: boolean;
      is_starred?: boolean;
    };

export type TaskFormModalOpenOptions = OpenOptionsBase & OpenOptionsExtra;

export class TaskFormModalStore implements BaseStore, ModalStore {
  appStore: AppStore;
  readonly modalId = "taskFormModal";

  @observable modalState = new DisclosureState<TaskFormModalOpenOptions>({
    onClose: () => {
      this.appStore.UIStore.dialogs.closeModal(this.modalId);
    },
    onOpen: () => {
      this.appStore.UIStore.dialogs.openModal({
        id: this.modalId,
        content: <ModalTaskCreate />,
      });
    },
  });

  constructor(appStore: AppStore) {
    makeObservable(this);
    this.appStore = appStore;
  }
}
